import React, { Component } from "react";
import { connect } from "react-redux";
import { redirectToLogin, redirectToLogout } from "../common/redirectActions";
import { FormattedMessage } from "react-intl";

class LoggedOutMessage extends Component {
  render() {
    const show = this.props.show;
    return show ? (
      <div className="modal-wrap">
        <div className="backdrop"></div>
        {this.props.type === "logged-out" && (
          <div className="error-modal">
            <h1>
              <FormattedMessage
                id="error-logged-out-message-component-log-in-modal-title"
                defaultMessage={"Your session expired."}
                description="Session expired modal header"
              />
            </h1>
            <p>
              <FormattedMessage
                id="error-logged-out-message-component-log-in-modal-body"
                defaultMessage={"Sign in to continue"}
                description="Session expired modal body text"
              />
            </p>
            <div className="btn-group">
              <div
                className="btn btn-primary"
                onClick={() => {
                  this.props.dispatch(redirectToLogin());
                }}
              >
                <FormattedMessage
                  id="error-logged-out-message-component-log-in-modal-button"
                  defaultMessage={"Sign in"}
                  description="Button to log in again after the user session has expired"
                />
              </div>
            </div>
          </div>
        )}
        {this.props.type === "request-failed" && (
          <div className="error-modal">
            <h1>
              <FormattedMessage
                id="error-request-failed-component-log-in-modal-title"
                defaultMessage={"We're doing some maitenance..."}
                description="Request failed modal header"
              />
            </h1>
            <p>
              <FormattedMessage
                id="error-request-failed-component-log-in-modal-body"
                defaultMessage="Sorry for the inconvenience, please try again in a little while."
                description="Request failed modal body text"
              />
            </p>
            <div className="btn-group">
              <div
                className="btn btn-primary"
                onClick={() => {
                  this.props.dispatch(redirectToLogout());
                }}
              >
                <FormattedMessage
                  id="error-request-failed-component-try-again-modal-button"
                  defaultMessage={"Try again"}
                  description="Button to refresh view in request failed modal"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    ) : null;
  }
}

export default connect((state) => state.get("errors").toJS())(LoggedOutMessage);
